// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "comparison-table-hero-v2/" + chunkId + ".comparison-table-hero-v2.js";
};